import { createElementFromTemplate } from '../../dom';
import isEqual from 'lodash/isEqual';
const TEMPLATE = `
    <div class="ag-sleeve-cell">
        <span class="ag-sleeve-cell-aside"></span>
        <span class="ag-sleeve-cell-value"></span>
    </div>
`;
export class AgSleeveComponent {
    constructor() {
        this.eGui = createElementFromTemplate(TEMPLATE)[0];
    }
    init(params) {
        this.eAside = this.getGui().querySelector('.ag-sleeve-cell-aside');
        this.eValue = this.getGui().querySelector('.ag-sleeve-cell-value');
        this.refresh(params);
    }
    getGui() {
        return this.eGui;
    }
    refresh(params) {
        var _a, _b, _c;
        if (isEqual(params.value, this.lastValue)) {
            return false;
        }
        this.lastValue = params.value;
        this.eValue.innerHTML = (_b = (_a = params.getSleeveValue) === null || _a === void 0 ? void 0 : _a.call(params, params.value)) !== null && _b !== void 0 ? _b : params.value;
        const newClass = (_c = params.getSleeveClass) === null || _c === void 0 ? void 0 : _c.call(params, params.value);
        this.eAside.classList.remove(this.lastClass);
        this.lastClass = newClass;
        if (Boolean(newClass)) {
            this.eAside.classList.add(newClass);
        }
        return true;
    }
}
